import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import {
	FullName,
	GET_FULLNAME,
} from "components/data/session-user/SessionUser.js";
import CmsContentList from 'components/data/CmsContentList.js';
import CmsContentRenderer from 'components/data/CmsContentRenderer.js';
import HelmetOGTags from 'layouts/HelmetOGTags.js';
import CardList from 'components/account/CardList.js';
import Container from 'components/Container.js';
import ContactCustomerService from 'components/banners/ContactCustomerService.js';
import InfoPanel from 'components/InfoPanel.js';
import AddAnotherCardActions from 'components/account/AddAnotherCardActions.js';
import useStdQuery from "components/data/hooks/useStdQuery.js";
import LoadingIcon, { PageLoading, SIZES } from "components/icons/LoadingIcon.js";
import { maskedError } from "components/data/StdQuery.js";
import SetupSecurityQuestionsBanner from 'components/banners/SetupSecurityQuestions.js';
import PurchaseCharlieCardBanner from 'components/account/purchases/PurchaseCharlieCardBanner.js';
import { parse as qs_parse } from 'qs';
import { hasMaxTravelCards } from 'components/account/hasMaxTravelCards.js';

import {  useBreadcrumbCallback } from 'context/BreadcrumbProvider.js';
import {  getHomeBreadcrumbs } from 'pages/Home.js';
import { BreadcrumbItem } from 'components/breadcrumb/Breadcrumb.js';
import routeKeys from 'CustomerRouteKeys.js';
import { useExpiringFundingSources } from 'components/data/session-user/FundingSources.query.js';
import ExpiringPaymentMethodBanner from 'components/banners/ExpiringPaymentMethod.js';
import ExpiredPaymentMethodBanner from 'components/banners/ExpiredPaymentMethod.js';
import { useAllTransitAccounts } from 'components/data/transit-account/TransitAccount.js';

import * as infoPanel from 'components/InfoPanel.module.css';
import * as style from './CardSelection.module.css';

const cms = {
	header: 'miscText.dashboard-header',
	subHeader: 'miscText.dashboard-subheader',
	maxLimit: 'miscHtml.dashboard-addcard-maxlimit',
	infoAlt: 'miscHtml.dashboard-info-alternates',

};

export const getCharlieCardBreadcrumbs = () =>  [
	...getHomeBreadcrumbs(),
	<BreadcrumbItem
		routeKey={routeKeys.AccountCardSelection}
		key={"fullName"}
	>
		<FullName />
	</BreadcrumbItem>,
];

const CardSelection = () => {
	const location = useLocation();
	const [ consumedQueryParams, setConsumedQueryParams ] = useState(false);
	useBreadcrumbCallback(getCharlieCardBreadcrumbs);

	const query = qs_parse(location.search, {
		ignoreQueryPrefix: true,
	});

	const { data: nameData, loading: nameLoading, error: nameError } = useStdQuery(GET_FULLNAME);

	const {
		transitAccounts = [],
		loading: transitAccountsLoading,
		error: transitAccountsError,
	} = useAllTransitAccounts({});

	const {
		expiredFundingSources,
		expiringFundingSources,
	} = useExpiringFundingSources();

	return (
		<>
			<div>
				{query?.purchaseCard && !consumedQueryParams
					? <PurchaseCharlieCardBanner handleBannerClose={() => setConsumedQueryParams(true)} />
					: <SetupSecurityQuestionsBanner />
				}

				{expiringFundingSources?.length > 0
					? expiringFundingSources.map(source => <ExpiringPaymentMethodBanner key={source.id} expiringFundingSource={source}/>)
					: null
				}

				{expiredFundingSources?.length > 0
					? expiredFundingSources.map(source => <ExpiredPaymentMethodBanner key={source.id} expiredFundingSource={source}/>)
					: null
				}
			</div>

			<Container>
				<CmsContentList	list={Object.values(cms)}sharedVariables={{ firstname: nameData?.session.customer.contact.name.firstName }}>{() =>
					<>
						<HelmetOGTags title="Card Selection" />
						<div className={style.container}>
							<div className={style.header}>
								{nameLoading || nameError
									? "Welcome"
									: <CmsContentRenderer.H1
										className={style.pageTitle}
										contentKey={cms.header}
									/>
								}

								{transitAccounts?.length > 0
									? <CmsContentRenderer.P
										contentKey={cms.subHeader}
										className={style.pageSubhead}
										fallbackValue="Select a card to view information."
									/>
									: null}
							</div>

							{transitAccountsLoading
								? <LoadingIcon size={SIZES.component} />
								: transitAccountsError
									? maskedError
									: <CardList {...{ transitAccounts }} />}

							{hasMaxTravelCards(transitAccounts.length)
								? <InfoPanel>
									<CmsContentRenderer.Div
										className={infoPanel.content}
										contentKey={cms.maxLimit}
										fallbackValue="<p>You've reached the maximum number of cards allowed on this account. To remove a card from your account, select the card then navigate to the Card Settings page.</p>"
									/>
								</InfoPanel>
								: <AddAnotherCardActions />
							}

							<InfoPanel>
								<CmsContentRenderer.Div
									className={infoPanel.content}
									contentKey={cms.infoAlt}
									fallbackValue="<p>To view cards for other accounts that you manage, <a href='#accountmenu'>use the Account Selection menu</a> in the upper right hand corner of the screen.</p>"
								/>
							</InfoPanel>
						</div>
					</>}</CmsContentList>
			</Container>
			<ContactCustomerService />
		</>
	);
};

export default CardSelection;
